// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-upload .v-input__prepend-outer[data-v-61cd3602] {\n  display: none !important;\n}", ""]);
// Exports
module.exports = exports;
